import { Component, inject } from '@angular/core';
import { stages } from '../../ alcoholic-sales-permit.routes';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { ApplicationCommonComponent } from '../../../common/application.common.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { AlcoholicSalesPermitBaseInfoForm } from './forms/ alcoholic-sales-permit-base-info.form';
import { ReactiveFormsModule } from '@angular/forms';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { AlertComponent } from '../../../../../../common/alert/alert.component';
import { DatePickerComponent } from '../../../../../../common/date-picker/date-picker.component';

@Component({
  selector: 'app-alcoholic-sales-permit-base-info-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    AlertComponent,
    DatePickerComponent
  ],
  providers: [
    AlcoholicSalesPermitBaseInfoForm
  ],
  templateUrl: './alcoholic-sales-permit-base-info-section.component.html'
})
export class AlcoholicSalesPermitBaseInfoSectionComponent extends ApplicationCommonComponent {

  public stages: string[] = stages;

  public form: AlcoholicSalesPermitBaseInfoForm = inject(AlcoholicSalesPermitBaseInfoForm);

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues({
        ...app
      });
    }
  };

  public submitAndGoNext(): void {
    if (this.form.valid) {
      if (this.applicationId) {
        this.updateApplication('dane-identyfikacyjne', this.form.toWriteModel());
      } else {
        this.createApplication('dane-identyfikacyjne', this.form.toWriteModel());
      }
    } else {
      this.form.markAllAsTouched();
    }
  }
}
